import React from 'react';
import LandmarkAdapter from '@core/scripts/components/landmark-adapter';
import {Link} from '@bonprix/design-system';

export default function UserFlyoutLinkItem({url, landmark, text, hideUnderline = true}) {
    const sendLandmark = () => {
        LandmarkAdapter.sendClickLandmark(landmark);
    };

    return (
        <Link href={url} hideUnderline={hideUnderline} onClick={sendLandmark}>
            {text}
        </Link>
    );
}
